(function() {
  var section = document.querySelector('[data-ghost-features]');
  if (!section) return;

  var modal = section.querySelector('[data-ghost-feature-modal]');
  var modalPanel = section.querySelector('[data-ghost-feature-modal-panel]');
  var modalTitle = section.querySelector('[data-ghost-feature-modal-title]');
  var modalBody = section.querySelector('[data-ghost-feature-modal-body]');
  var modalIcon = section.querySelector('[data-ghost-feature-modal-icon]');
  var closeButtons = section.querySelectorAll('[data-ghost-feature-modal-close]');
  var focus = window.GhostModalFocus;

  var iconMarkup = {
    shield: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3L4 7v6c0 5 3.5 9.5 8 10 4.5-.5 8-5 8-10V7l-8-4z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    x: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    smartphone: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="7" y="2.5" width="10" height="19" rx="2" stroke="currentColor" stroke-width="2"/><path d="M11 18.5h2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    radio: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4.5 12a7.5 7.5 0 0115 0" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M8 12a4 4 0 018 0" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/></svg>',
    shield_check: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3L4 7v6c0 5 3.5 9.5 8 10 4.5-.5 8-5 8-10V7l-8-4z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 12.5l1.8 1.8 3.7-3.7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    lock: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" stroke-width="2"/><path d="M8 11V8a4 4 0 118 0v3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };

  function openModal(trigger) {
    if (!modal || !modalTitle || !modalBody || !modalIcon) return;

    var title = trigger.getAttribute('data-modal-title') || '';
    var body = trigger.getAttribute('data-modal-body') || '';
    var icon = trigger.getAttribute('data-icon') || 'shield';

    modalTitle.textContent = title;
    modalBody.textContent = body;
    modalIcon.innerHTML = iconMarkup[icon] || iconMarkup.shield;

    if (focus) focus.rememberFocus();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (focus) focus.focusInitial(modalPanel, '[data-ghost-feature-modal-close]');
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (focus) focus.restoreFocus();
  }

  section.querySelectorAll('[data-ghost-feature-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      openModal(trigger);
    });
  });

  closeButtons.forEach(function(button) {
    button.addEventListener('click', closeModal);
  });

  if (modal) {
    modal.addEventListener('click', function(event) {
      if (event.target === modal) closeModal();
    });
  }

  document.addEventListener('keydown', function(event) {
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (focus) focus.trapTab(event, modalPanel);
  });
})();
